import React, { useState } from "react";
import { useForm } from "react-hook-form";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { toast } from "react-toastify";
import moment from "jalali-moment";

// import JS files
import PanelTemplate from "../../shares/PanelTemplate";
import MuiButton from "../../shares/MuiButton";
import useFetch from "../../../context/useFetch";
import MuiTextField from "../../shares/MuiTextField";
import { EmptyData, fixNumbers, translateLog } from "../../../utils";



const OrderLogs = (props) => {
  const {
    register,
    handleSubmit,
    watch,
    setError,
    control,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    defaultValues: {},
  });

  const [orderDetail, setOrderDetail] = useState([]);
  const [orderCode, setOrderCode] = useState(null);

  const getOrderApi = useFetch({
    method: "post",
    url: `Order_Service/get_order_log_using_order_id`,
    trigger: false,
    data: {
      unique_id: fixNumbers(orderCode),
    },
    argFunc: (res) => {
      setOrderDetail(res);
    },
    errMessage: (mess) => {
      toast.error("شماره سند وجود ندارد", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const show_order_details = () => {
    if (orderCode !== null) {
      getOrderApi.reFetch();
    }
  };

  return (
    <>
      <PanelTemplate sidebarActiveLink="q-log-order">
        <div className="panel-main-header">
          <span className="">رکورد‌های سفارش</span>
        </div>
        <div className="grid md:grid-cols-5 gap-y-6 gap-x-4 border-dashed border-b pb-4">
          <div className="">
            <MuiTextField
              id="outlined-basic"
              label="شماره سند"
              variant="outlined"
              size="small"
              name="name"
              control={control}
              onChange={(e) => setOrderCode(e.target.value)}
              register={{
                required: {
                  value: true,
                  message: "شماره سند را وارد کنید.",
                },
              }}
            />
          </div>

          <div className="">
            <MuiButton
              onClick={show_order_details}
              variant="contained"
              icon={<ArrowDownwardIcon />}
              color="primary"
              text=" نمایش اطلاعات سفارش "
              disabled={getOrderApi.loading}
              isFullWidth
            />
          </div>
        </div>
        <div className="grid grid-cols-4 md:grid-cols-6 gap-4 mt-4 bg-myblue-200 text-white px-4 py-2 text-center">
          <span className="md:col-span-1">نام</span>
          <span className="md:col-span-1">نقش</span>
          <span className="md:col-span-1">تاریخ</span>
          <span className="md:col-span-3">توضیحات</span>
        </div>
        {orderDetail.map((log, index) => {
          return (
            <div className="grid grid-cols-4 md:grid-cols-6 gap-4 px-4 py-2 text-center border-b border-dashed text-xs md:text-sm ">
              <span className="md:col-span-1">
                {log.creator.first_name + " " + log.creator.last_name}
              </span>
              <span className="md:col-span-1">
                {log.creator.job == "Admin"
                  ? "مدیر"
                  : log.creator.job == "Customer"
                  ? "مشتری"
                  : "تولیدکننده"}
              </span>
              <span className="md:col-span-1">
                {" "}
                {moment(log.created_at, "YYYY/MM/DD")
                  .locale("fa")
                  .format("YYYY/MM/DD")}
              </span>
              <span className="md:col-span-3">{translateLog(log.state)}</span>
            </div>
          );
        })}
      </PanelTemplate>
    </>
  );
};

export default OrderLogs;
